export const PRODUCT_NAME_REQUIRED = 'Product Name is Required';
export const PRODUCT_CODE_REQUIRED = 'Product Code is Required'
export const PRODUCT_CATEGORY_REQUIRED = 'Product Category is Required'
export const INVALID_FILE_FORMAT = 'Invalid File Type'

export const jobCardValidations = {
    JOBCARD_TYPE_REQUIRED: 'Jobcard Type Required',
    VEHICLE_NO_REQUIRED: 'Vehicle No. Required',
    BRANCH_REQUIRED: 'Branch Required',
    VENDOR_REQUIRED: 'Vendor Required',
    BILL_NO_REQUIRED: 'Bill No Required',
    INVALID_CHARACTERS: 'Invalid Characters',
    ONLY_NO_REQUIRED: 'Only Numbers Required',
    ADD_PRODUCT_SERVICE: 'Add a product/service',
    QUANTITY_IS_REQUIRED: 'Quantity is required',
    RATE_IS_REQUIRED: 'Rate is required',
    VEHICLE_IN_DATE_REQUIRED: 'Vehicle In Date Required',
    VEHICLE_OUT_DATE_REQUIRED: 'Vehicle Out Date Required',
    METER_READING_REQUIRED: 'Meter Reading Required',
    ONLY_NUMBERS_REQUIRED: 'Only Numbers Required',
    SHOULD_BE_MORE_THAN_0: 'Should be more than 0',
    SHOULD_BE_MORE_THAN_1: 'Should be more than 1',
}

export const jobcardTitles = {
   JOBCARD_TYPE : 'Jobcard Type',
   REF_NO : 'Reference Number',
   JOBCARD_ACTIVITY : 'Jobcard Activity',
   VEHICLE_NO : 'Vehicle Number',
   VEHICLE_TYPE : 'Vehicle Type',
   METER_READING : 'Meter Reading',
   BRANCH : 'Branch',
   VEHICLE_EXPENSE_DATE :'Vehicle Expense Date',
   VEHICLE_IN_DATE : 'Vehicle In Date',
   VENDOR : 'Vendor',
   VEHICLE_OUT_DATE : 'Vehicle Out Date',
   JOBCARD_NO : 'Jobcard Number'

}